import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { AuthService } from '../../auth/auth.service';

@Component({
  selector: 'app-fte-modal',
  standalone: false,
  templateUrl: './fte-modal.component.html',
  styleUrl: './fte-modal.component.scss'
})
export class FTEModalComponent {

  constructor(
    public dialogRef: MatDialogRef<FTEModalComponent>,
    private readonly authService: AuthService,
  ) { }

  FTEYesAction(): void {
    // will take youser to ISCP flow
    this.authService.setIsFTEuser(true);
    this.dialogRef.close('yes');
  }

  FTENoAction(): void {
    // will take youser to Test-out flow
    this.dialogRef.close('no');
  }

}
